import {Pipe, PipeTransform} from '@angular/core';
import {LocalDate} from '@js-joda/core';
import {LocalDateUtil} from '../utils/date-time/local-date.util';

/** Типизированное отображение LocalDate через LocalDateUtil; строки и Date не принимает. */
@Pipe({name: 'localDateFormat'})
export class LocalDateFormatPipe implements PipeTransform {
  /** Шаблон js-joda; по умолчанию dd.MM.yyyy. Отсутствующая дата отображается пустой строкой. */
  public transform(value: LocalDate | null | undefined, pattern = 'dd.MM.yyyy'): string {
    return LocalDateUtil.toFormattedString(value, pattern);
  }
}
